import { ycrAssetType } from "../../../constant";


const priceDetailsReducer = (state = false, action) => {
    switch (action.type) {
        case ycrAssetType.FETCH_INTEREST_RATES_DATA_TYPES_DETAILS_ASSET:
            return action.payload;
        default:
            return state;
    }
}
export default priceDetailsReducer